import React from "react";
import style from "./index.module.scss";
import { guideData } from "@/assets/data/pageData";

function Schedule(props) {
  const isFirefox = navigator.userAgent.indexOf("Firefox") > 0;

  return (
    <div className={`${style.task_nav} ${isFirefox ? style.fire : ""}`}>
      <div className={`${style.task_num} ${props.task1Active ? style.active : ""}`}>1<span>{ guideData.commRuleTitle }</span></div>
      <div className={`${style.task_line} ${props.task2Active ? style.active : ""}`}></div>
      <div className={`${style.task_num} ${props.task2Active ? style.active : ""}`}>2<span>{ guideData.nonRuleTitle2 }</span></div>
      <div className={`${style.task_line} ${props.task3Active ? style.active : ""}`}></div>
      <div className={`${style.task_num} ${props.task3Active ? style.active : ""}`}>3<span>{ guideData.completeTitle }</span></div>
    </div>
  );
}

export default Schedule;